"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _constant = require("../Theme/constant");

var _text = _interopRequireDefault(require("./text.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var TextContainer = _styledComponents.default.p.withConfig({
  displayName: "Text__TextContainer",
  componentId: "sc-xqubq8-0"
})(["display:", ";align-items:", ";font-weight:", ";font-family:", ";font-size:", ";color:", ";text-decoration:", ";text-align:", ";margin-left:", ";margin-top:0px;margin-right:0px;margin-bottom:", ";line-height:", ";opacity:", ";"], function (_ref) {
  var display = _ref.display;
  return display;
}, function (_ref2) {
  var verticalAlign = _ref2.verticalAlign;
  return verticalAlign;
}, function (_ref3) {
  var bold = _ref3.bold,
      fontWeight = _ref3.fontWeight,
      theme = _ref3.theme;
  return bold ? theme.fontWeight[fontWeight] || theme.fontWeight.bold : theme.fontWeight.normal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.fontFamily.default, ", Roboto");
}, function (_ref5) {
  var theme = _ref5.theme,
      type = _ref5.type;
  return theme.fontSize[_constant2.TEXT_TYPE[type] ? _constant2.TEXT_TYPE[type].size : _constant2.TEXT_TYPE.default.size];
}, function (_ref6) {
  var color = _ref6.color,
      theme = _ref6.theme;
  return color ? theme.colors[color] : theme.colors.neutral;
}, function (_ref7) {
  var strikethrough = _ref7.strikethrough;
  return strikethrough ? 'line-through' : 'none';
}, function (_ref8) {
  var textAlign = _ref8.textAlign;
  return textAlign || 'initial';
}, function (_ref9) {
  var marginLeft = _ref9.marginLeft,
      theme = _ref9.theme;
  return _constant.ARR_SPACING_TYPES.indexOf(marginLeft) > 0 ? theme.space[marginLeft] : '0px';
}, function (_ref10) {
  var marginBottom = _ref10.marginBottom,
      theme = _ref10.theme;
  return _constant.ARR_SPACING_TYPES.indexOf(marginBottom) > 0 ? theme.space[marginBottom] : '0px';
}, function (_ref11) {
  var theme = _ref11.theme,
      type = _ref11.type;
  return _constant2.TEXT_TYPE[type] && theme.lineHeight ? theme.lineHeight[_constant2.TEXT_TYPE[type].lineHeight] : '0px';
}, function (_ref12) {
  var opacity = _ref12.opacity;
  return opacity;
});

var StyledToggle = _styledComponents.default.a.withConfig({
  displayName: "Text__StyledToggle",
  componentId: "sc-xqubq8-1"
})(["text-decoration:none;color:", ";margin-left:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.secondary;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.tiny;
});

var limitCharacters = function limitCharacters(value) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  if (value && value.length > limit) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value.substr(0, limit), "...");
  }

  return value;
};

var Text = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var accessible = props.accessible,
      type = props.type,
      textLimit = props.textLimit,
      theme = props.theme,
      bold = props.bold,
      strikethrough = props.strikethrough,
      direction = props.direction,
      color = props.color,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      textAlign = props.textAlign,
      customProperties = props.customProperties,
      children = props.children,
      className = props.className,
      display = props.display,
      verticalAlign = props.verticalAlign,
      hasToggle = props.hasToggle,
      translation = props.translation,
      tag = props.tag,
      opacity = props.opacity;

  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      toggle = _React$useState2[0],
      setToggle = _React$useState2[1];

  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var handleToggle = function handleToggle(e) {
    e.preventDefault();
    setToggle(!toggle);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(TextContainer, (0, _extends2.default)({
      as: tag,
      ref: ref,
      display: _constant2.DISPLAY[display],
      type: type,
      bold: bold,
      strikethrough: strikethrough,
      color: color,
      tabIndex: tabIndex,
      dir: direction,
      marginBottom: marginBottom,
      marginLeft: marginLeft,
      className: className,
      textAlign: textAlign,
      theme: themeContext,
      verticalAlign: _constant2.VERTICAL_ALIGN[verticalAlign],
      opacity: opacity
    }, customProperties), textLimit !== undefined && !toggle && limitCharacters(children, textLimit) || children, hasToggle && /*#__PURE__*/_react.default.createElement(StyledToggle, {
      href: "#!",
      onClick: handleToggle
    }, toggle ? language.less : language.more));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
});
Text.propTypes = _text.default.PropTypes;
Text.defaultProps = _text.default.DefaultProps;
var _default = Text;
exports.default = _default;